import {FC, useState, useRef} from 'react';

import {t} from 'i18next';

import {useAppSelector} from 'hooks';
import {useAppMode} from 'hooks/useAppMode';
import {useCarouselEventHandler} from 'hooks/useCarouselEventHandler';
import ReactNative from 'services/react-native';
import SendBrowserEvent from 'services/send-browser-event';
import {EventMessagesType} from 'types';
import {getPreviewItemsWithBasketItems} from 'utils/basket';
import {geSearchCarouselUrl, getBasketRecommendationTitle} from 'utils/recommendation-utils/recommendations';

import {StyledIFrame} from './styles/styledIFrame.style';

export const RecommendationsCarouselMFE: FC = () => {
  const iframeRef = useRef<HTMLIFrameElement | null>(null);

  const {isExpress} = useAppMode();
  const {recommendations} = useAppSelector((state) => state.recommendations);

  const currentStore = useAppSelector((state) => state?.app?.currentStore);
  const {idToken: accessToken, customerId: userId} = useAppSelector((state) => state?.auth);
  const {basket} = useAppSelector((state) => state?.basket);

  const [isEmptyCarousel, setIsEmptyCarousel] = useState(false);

  const handleOnSeeAllClick = (analyticsPayload: any) => {
    SendBrowserEvent.goToPLP('recommendations', analyticsPayload);
  };

  const handleIframeReady = () => {
    setTimeout(() => {
      const previewBasketItems = basket?.basketItems?.length ? getPreviewItemsWithBasketItems(basket.basketItems) : [];

      iframeRef.current?.contentWindow?.postMessage(
        {
          type: EventMessagesType.BASKET_ITEMS,
          message: JSON.stringify(previewBasketItems)
        },
        '*'
      );
    }, 200);
  };

  useCarouselEventHandler({
    onSeeAllClick: handleOnSeeAllClick,
    onEmptyCarousel: (isEmpty: boolean) => {
      setIsEmptyCarousel(isEmpty);
    }
  });

  const carouselUrl = geSearchCarouselUrl({
    title: `${t(getBasketRecommendationTitle(recommendations.recommendationType ?? ''))}`,
    stores: currentStore?.storeCodes || [],
    accessToken,
    isExpressMode: isExpress,
    recommendationVariant: 'basketRecommendation',
    userId,
    sameDay: currentStore?.isSameDayDelivery,
    platform: ReactNative.isReactNativeWebView() ? 'app' : 'web'
  });

  if (isEmptyCarousel) {
    return null;
  }
  return <StyledIFrame ref={iframeRef} src={carouselUrl} className={'iframeCarousel'} onLoad={handleIframeReady} />;
};
